module.exports = __webpack_public_path__ + "img/Google_Calendar.max-1100x1100.6dbcab07.svg";